'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import tkns from '@lualtek/tokens/web/tokens.json';
import clsx from 'clsx';
import { forwardRef, useMemo } from 'react';
import styles from './text.module.css';
export const Text = forwardRef(({ as: Component = 'span', children, className, size, sentiment, dimmed, weight, maxWidth, align = 'start', responsive = true, lineHeight = 'standard', textColor, whiteSpace = 'normal', balanced = false, hPadding, vPadding, style, ...otherProps }, forwardedRef) => {
    const dynamicStyle = useMemo(() => {
        const getPaddingValue = (padding, direction) => {
            const [start, end] = Array.isArray(padding) ? padding : [padding, padding];
            return direction === 'horizontal'
                ? { left: start ? tkns.space[start] : 0, right: end ? tkns.space[end] : 0 }
                : { top: start ? tkns.space[start] : 0, bottom: end ? tkns.space[end] : 0 };
        };
        const vPaddingValues = vPadding ? getPaddingValue(vPadding, 'vertical') : { top: 0, bottom: 0 };
        const hPaddingValues = hPadding ? getPaddingValue(hPadding, 'horizontal') : { left: 0, right: 0 };
        return {
            '--max-w': maxWidth,
            '--t-align': align,
            '--text-color': textColor,
            '--white-space': whiteSpace,
            '--v-padding-top': vPaddingValues.top,
            '--v-padding-bottom': vPaddingValues.bottom,
            '--h-padding-left': hPaddingValues.left,
            '--h-padding-right': hPaddingValues.right,
        };
    }, [maxWidth, align, textColor, whiteSpace, hPadding, vPadding]);
    return (_jsx(Component, { ref: forwardedRef, "data-text-size": size, "data-text-weight": weight, "data-text-sentiment": sentiment, "data-text-dimmed": dimmed, "data-text-line-height": lineHeight, "data-text-responsive": size === 12 ? false : responsive, "data-text-balanced": balanced, "data-text-has-padding": Boolean(hPadding ?? vPadding), className: clsx(styles.Text, className), style: { ...dynamicStyle, ...style }, ...otherProps, children: children }));
});
